export { RENDERER_TYPE, timeRenderer } from "./timeRenderer.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/renderers/timeRenderer/index.mjs
// module id = 578
// module chunks = 1